<template>
  <b-modal
    @show="onShow"
    @hide="onCancel"
    dialog-class="md_modal_dialog_full2"
    body-class="md_modal_body_scroll2 pt-0"
    modal-class="md_modal_full"
    content-class="md_modal_content_full"
    header-class="dlg_header"
    :visible="visible"
    hide-footer
    hide-backdrop
    no-close-on-backdrop
  >
    <template #modal-header="{close}">
        <div class="popup_title" style="flex: 1; text-align: center;">
          <template v-if="type == SITE_SELECT.COMPLETE">
          {{ $t('more.sale_complete') }}
          </template>
          <template v-if="type == SITE_SELECT.TRANSFER">
            {{ $t('site_report.site_transfer') }}
          </template>
        </div>
        <b-button class="dlg_close_btn" variant="white" @click="onCancel">
          <b-img :src="require('../../../assets/image/ic_close2.png')" style="height: 1em; margin-left: 7px; margin-right: 3px; "/>
        </b-button>
    </template>
    <div class="container pt-2" style="width: 100%; max-height: 100vh; overflow-y: auto" @scroll="onScroll" ref="wrap">
      <b-nav justified class="md_tab_header tab_bar">
        <!-- <b-nav-item>'s with child routes. Note the trailing slash on the first <b-nav-item> -->
        <b-nav-item @click="activeTab=TAB.ALL"  link-classes="tab-item" :class="{'md_active' : (activeTab==TAB.ALL)}">{{$t('map.my_site')}}</b-nav-item>
        <b-nav-item @click="activeTab=TAB.GROUP"  link-classes="tab-item" >{{$t('map.group_site')}}</b-nav-item>
      </b-nav>
      <div class="align-vertical mb-2" style="opacity: 1; background-color: white;" v-if="activeTab == TAB.GROUP">
        <div class="align-horizontal" style="height: 50px; position: relative">
<!--          <b-img :src="require('../../../assets/image/ic_link.png')" class="img_link" />-->
          <b-button :variant="selectedGroup ? 'primary' : 'secondary'"
                    class="flex_1 center bottom_btn_text no_border_radius" style="height: 50px"
                    :style="{backgroundColor : selectedGroup ? '#457fff' : '#cacbcd' }"
                    @click="onShowGroup">
            {{selectedGroup ? selectedGroup.f_name : $t('group.no_group')}}
          </b-button>
<!--          <b-button class="flex_1 center bottom_btn_text no_border_radius"-->
<!--                    style="color: #457fff; background-color: #E6F0FD; height: 50px" @click="onShowGroupMemberMng">-->
<!--            {{$t('group.group_member_mng')}}-->
<!--          </b-button>-->
        </div>
        <div class="align-vertical" v-if="showGroupList">
          <div class="align-vertical"
               style="overflow-y: auto"
               :style="{height: String(45 * Math.min(5, myGroupList.length)) + 'px'}">
            <b-button class="flex_1 center bottom_btn_text no_border_radius"
                      v-for="(item, index) in myGroupList"
                      :key="`group-${index.toString()}`"
                      style="height: 45px"
                      variant="white"
                      :style="{
                          color: (!selectedGroup || selectedGroup.f_idx != item.f_idx) ? '#457fff': 'white',
                          backgroundColor: (!selectedGroup || selectedGroup.f_idx == item.f_idx) ? '#96B7FF': 'white'
                        }"
                      @click="() => {
                        u.setState(self, {selectedGroup: item, showGroupList: false}, () => {
                          self.getSitesOfGroup(item.f_idx);
                        })}">
              {{item.f_name}}
            </b-button>
          </div>
        </div>
        <div class="align-vertical" v-if="showGroupMemberMng">
          <div class="align-horizontal" style="height: 50px; justify-content: space-around; border-bottom: solid 1px #cacbcd">
            <span class="bottom_btn_text flex_1" style="color: #457fff; text-align: center;">{{$t('group.name')}}</span>
            <span class="bottom_btn_text flex_1" style="color: #457fff; text-align: center;">{{$t('group.member_number')}}</span>
          </div>
          <div class="align-vertical" style="overflow-y: auto">
            <div class="align-horizontal center" style="height: 50px; justify-content: space-around"
                 v-for="(item, index) in groupMemberList" :key="`group_member-${index.toString()}`">
              <span class="bottom_btn_text flex_1" style="color: black; text-align: center;">{{item.f_user_name}}</span>
              <span class="bottom_btn_text flex_1" style="color: black; text-align: center;">{{u.formatPhoneNumber(item.f_phone)}}</span>
            </div>
          </div>
        </div>
      </div>
      <SiteItem v-for="(item, index) in list"
                :key="`sale-${index.toString()}`"
                :item="item"
                :show-btn="false"
                :is-transfer = "type == SITE_SELECT.TRANSFER ? true : false"
                :is-admin="type !== SITE_SELECT.COMPLETE"
                @onCell="onCell(item)"
                :onlySelect="type !== SITE_SELECT.TRANSFER" />
      <div class="full align-vertical" v-if="list.length === 0">
        <span class="no_item">{{$t('more.no_site')}}</span>
      </div>
    </div>

  </b-modal>
</template>

<script>
import {TAB} from '../../contents/main/sale/SaleList'
import Utils from '../../../config/utils'
import SiteItem from "../SiteItem";
const utils = require('util');
export const SITE_SELECT = {
  PICKER: 1,      // for site select
  COMPLETE: 2,    // for sale-complete site list
  TRANSFER: 3,    // for sale-transfer site list
};
export default {
  name: "SiteSelectPopup",
  components: {SiteItem},
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
    type: {
      default: SITE_SELECT.COMPLETE
    }
  },
  watch: {
    activeTab: function (newVal, oldVal){
      this.pageNum = 1;
      this.loadingEnd = false;
      if (newVal == TAB.ALL) {
        this.getSiteList();
      } else if (newVal == TAB.GROUP) {
        this.goToGroupMaemul();
      }
    }
  },
  data() {
    return {
      self: this,
      u: Utils,
      ut: utils,
      SITE_SELECT: SITE_SELECT,
      TAB: TAB,
      list: [],
      showLoading: false,
      loadingEnd: false,
      activeTab: TAB.ALL,
      pageNum: 1,

      showGroupList: false,
      showGroupMemberMng: false,
      selectedGroup: null,
      myGroupList: [],
      groupMemberList: [],
    }
  },
  mounted() {

  },
  inject: ['eventBus'],
  methods:{
    onShow() {
      this.eventBus.$emit('setModal', this);
      window.history.pushState('forward', null,);
      if (this.type == SITE_SELECT.COMPLETE) {
        this.loadingEnd = false;
        this.pageNum = 1;
        this.getSiteList();
      } else {
        this.activeTab=TAB.ALL;
        this.loadingEnd = false;
        this.pageNum = 1;
        this.getSiteList();
      }
      this.eventBus.$on('sale_complete', () => {
        Utils.toast(this, this.$t('site_report.transfer_site_done'));
        if (this.activeTab === TAB.GROUP)
          this.getSitesOfGroup();
        else
          this.getSiteList();
      });
    },
    onCancel()  {
      if (this.visible) {
        if (window.history.state == "forward")
          window.history.back();
        // this.$emit('update:visible', false);
        // this.$emit('onCancel');
        this.list = [];
      }
    },
    onShowGroup() {
      if (!this.showGroupList) {
        Utils.requestGet(this.$c.API.Group.getMyGroupList, []).then(result => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            Utils.setState(this,{
              showGroupList: true,
              showGroupMemberMng: false,
              myGroupList: result.data,
            });
          } else
            Utils.toast(this,result.msg);
        });
      } else
        Utils.setState(this,{
          showGroupList: false,
          showGroupMemberMng: false,
        });
    },
    onShowGroupMemberMng() {
      if (this.selectedGroup) {
        Utils.requestGet(this.$c.API.Group.getMembersOfGroup, {group_idx: this.selectedGroup.f_idx}).then(result => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS)
            Utils.setState(this,{
              showGroupList: false,
              showGroupMemberMng: !this.showGroupMemberMng,
              groupMemberList: result.data.list,
            });
          else
            Utils.toast(this,result.msg);
        });
      } else {
        Utils.toast(this, this.$t('group.select_group'));
      }
    },
    goToGroupMaemul(){
      Utils.setState(this,{list: [], activeTab: TAB.GROUP}, () => {
        Utils.requestGet(this.$c.API.Group.getRecentVisitGroup, {}).then(result => {
          if(result.code == this.$c.API_RES_CODE.SUCCESS) {
            Utils.setState(this,{selectedGroup: result.data.recentGroup.f_name ? result.data.recentGroup : null}, () => {
              this.getSitesOfGroup();
            });
          }
        });
      });
    },

    getSitesOfGroup() {
      if (this.selectedGroup) {
        Utils.requestGet(this.$c.API.Site.getSiteOfGroup,
          {group_idx: this.selectedGroup.f_idx, is_only_new_open_site: this.type === SITE_SELECT.COMPLETE}).then(result => {
          if(result.code == this.$c.API_RES_CODE.SUCCESS)
            Utils.setState(this,{list: result.data.list});
          else {
            Utils.toast(this,result.msg);
          }
        });
      } else
        Utils.setState(this,{list: []});
    },

    onScroll(){
      if (this.list.length === 0)
        return;
      else {
        let wrap = this.$refs.wrap;
        if(wrap.scrollHeight - Math.ceil(wrap.scrollTop) === wrap.clientHeight){ //end of scroll
          if (!this.loadingEnd){
            this.getSiteList();
          }
        }
      }
    },
    getSiteList () {
      if (this.loadingEnd) {
        return;
      }
      Utils.setState(this,{showLoading: true});
      Utils.requestGet(
        this.type == SITE_SELECT.PICKER || this.type == SITE_SELECT.TRANSFER ?
          this.$c.API.Site.getMySiteList : this.$c.API.Site.getMyOpenSaleList,
        {
          site_type: this.type == SITE_SELECT.COMPLETE ? TAB.NEW : this.type == SITE_SELECT.TRANSFER ? null : this.activeTab,
          page_num: this.pageNum,
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          Utils.setState(this,{
            list: this.list.concat(result.data.list),
            showLoading: false,
            loadingEnd: result.data.count > result.data.list.length,
            pageNum: ++this.pageNum,
          });
          console.log(this.loadingEnd);
        } else {
          Utils.setState(this,{showLoading: false});
          Utils.toast(this, result.msg);
        }
      });
    },

    onCell(item) {
      if (this.type == SITE_SELECT.PICKER)
        this.onCancel()
      this.$emit('select', item);
    },

  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/_vars.scss";
.tab-item {
  color:black;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}
.nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottom_btn_text {color: $white; font-size: $fs_18; font-family: $korean_gd_15_r}
.no_item {
  color: black;
  font-size: $fs_20;
  font-family: $korean_gd_13_r;
  margin-top: 100px;
  align-self: center;
}
.img_link {
  position: absolute;
  top: calc(50% - 5px);
  left: calc(50% - 12px);
  z-index: 1;
}

</style>



// WEBPACK FOOTER //
// src/components/controls/popup/SiteSelectPopup.vue